<template>
  <div id="FactCustomerInfo" class="section">
    <div class="columns is-multiline is-mobile">
      <!-- PERSONAL INFO. -->
      <div class="column is-6-desktop is-12-tablet is-12-mobile">
        <p class="title is-4 has-text-left">ข้อมูลส่วนตัว</p>
        <div class="columns has-text-left">
          <div class="column">
            <div class="columns is-multiline is-align-end">
              <div class="column is-8">
                <b-field label="ชื่อ-นามสกุล">
                  <b-input
                    v-model="customer_fullname"
                    placeholder="WEALTH NAVI"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="ชื่อเล่น">
                  <b-input v-model="customer_nickname" placeholder="App" />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="อาชีพ">
                  <b-input v-model="customer_career" />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="วันเกิด">
                  <b-datepicker
                    icon="calendar-today"
                    trap-focus
                    :max-date="maxDate"
                    :years-range="[-100, 100]"
                    v-model="customer_birthdate"
                  />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="เพศ">
                  <b-select expanded v-model="customer_gender">
                    <option :value="null">กรุณาระบุเพศ</option>
                    <option value="M">ชาย</option>
                    <option value="F">หญิง</option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field label="รายได้เฉลี่ยต่อเดือน">
                  <b-input type="number" min="0" v-model="customer_income" />
                </b-field>
              </div>
              <div class="column is-6">
                <b-field label="ค่าใช้จ่ายส่วนตัว">
                  <b-input type="number" min="0" v-model="customer_expense" />
                </b-field>
              </div>
              <div class="column is-6">
                <b-field label="ค่าใช้จ่ายครอบครัว">
                  <b-input type="number" min="0" v-model="family_expense" />
                </b-field>
              </div>
              <div class="column is-6">
                <b-field label="เหลือออมเพื่อลงทุน">
                  <b-input type="number" v-model="net_saving" disabled />
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- OFFSET + HIDDEN -->
      <div class="column is-1 is-hidden-touch"></div>
      <!-- CHILDERN INFO. -->
      <div class="column">
        <p class="title is-4 has-text-left">
          ข้อมูลบุตร
          <b-button
            size="is-small"
            type="is-primary"
            icon-right="plus"
            @click.prevent="addChildButtonPressed()"
          />
        </p>
        <div class="columns has-text-left is-centered is-multiline">
          <div v-if="kids.length > 0" class="column">
            <div
              v-for="(kid, index) in kids"
              :key="index"
              class="columns is-align-end"
            >
              <div class="column is-4">
                <b-field label="ชื่อเล่น">
                  <b-input v-model="kid.name" />
                </b-field>
              </div>
              <div class="column is-4">
                <b-field label="วันเกิด">
                  <b-datepicker
                    trap-focus
                    icon="calendar-today"
                    :max-date="maxDate"
                    :years-range="[-100, 100]"
                    v-model="kid.dob"
                  />
                </b-field>
              </div>
              <div class="column is-3">
                <b-field label="เพศ">
                  <b-select expanded v-model="kid.gender">
                    <option :value="null">กรุณาระบุเพศ</option>
                    <option value="M">ชาย</option>
                    <option value="F">หญิง</option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-1">
                <b-button
                  outlined
                  size="is-small"
                  type="is-danger"
                  icon-right="delete"
                  @click.prevent="removeChildButtonPressed(index)"
                />
              </div>
            </div>
          </div>
          <div v-else class="column has-text-centered">
            <p class="subtitle is-6" style="padding-top: rem">ไม่มีบุตร</p>
          </div>
        </div>
      </div>
    </div>

    <!-- ICON -->
    <div class="columns is-multiline is-mobile" style="padding-top: 2rem">
      <div class="column is-12 has-text-left">
        <p class="title is-4">
          เป้าหมายวางแผนการเงิน
          <b-button
            size="is-small"
            type="is-primary"
            icon-right="plus"
            @click.prevent="presentTargetSelected()"
          />
        </p>
      </div>
    </div>
    <!-- Customer Registration -->
    <div v-if="targets">
      <div v-for="(target, index) in targets" :key="index" class="columns">
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <img
            v-if="target.type === 'retire'"
            src="@/assets/factsheet_icons/target_retirement.svg"
          />
          <img
            v-else-if="target.type === 'education'"
            src="@/assets/factsheet_icons/target_education.svg"
          />
          <img
            v-else-if="target.type === 'tax'"
            src="@/assets/factsheet_icons/target_tax.svg"
          />
          <img
            v-else-if="target.type === 'health'"
            src="@/assets/factsheet_icons/target_protection.svg"
          />
          <img
            v-else-if="target.type === 'family'"
            src="@/assets/factsheet_icons/target_family.svg"
          />
          <img v-else src="@/assets/factsheet_icons/target_investment.svg" />
        </div>
        <div
          class="column has-text-left is-10-desktop is-8-tablet is-12-mobile"
        >
          <b-field :label="target.title">
            <b-input
              maxlength="120"
              type="textarea"
              :value="target.value"
              @input="textareaChange($event, index)"
            ></b-input>
          </b-field>
        </div>
      </div>
    </div>

    <div class="btn-mt">
      <div class="btn-mt">
        <div class="columns is-centered">
          <div
            v-if="edited"
            class="column is-2-desktop is-4-tablet is-12-mobile"
          >
            <b-button
              outlined
              expanded
              type="is-primary"
              class="prompt-font"
              @click.prevent="updateFactInfoState()"
            >
              บันทึก
            </b-button>
          </div>
          <div class="column is-2-desktop is-4-tablet is-12-mobile">
            <b-button
              expanded
              type="is-primary"
              class="prompt-font"
              :disabled="disabledNextButton"
              @click.prevent="saveFactSheetInfoState()"
            >
              ต่อไป
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TargetSelectedForm from "@/components/forms/TargetSelectedForm.vue";

export default {
  name: "FactCustomerInfo",
  props: ["edited"],
  data() {
    return {
      maxDate: new Date(),
      customer_idcard: null,
      customer_fullname: null,
      customer_nickname: null,
      customer_birthdate: null,
      customer_career: null,
      customer_gender: null,
      customer_income: null,
      customer_expense: null,
      family_expense: null,
      kids: [],
      targets: null
    };
  },
  computed: {
    ...mapState(["client", "factsheet_target"]),
    net_saving: function() {
      if (this.customer_income && this.customer_expense) {
        if (this.family_expense) {
          return (
            +this.customer_income -
            (+this.customer_expense + +this.family_expense)
          );
        }
        return +this.customer_income - +this.customer_expense;
      } else {
        return null;
      }
    },
    disabledNextButton: function() {
      if (
        this.customer_fullname &&
        this.customer_fullname !== "" &&
        this.customer_career &&
        this.customer_career !== "" &&
        this.customer_birthdate &&
        this.customer_gender &&
        this.customer_income &&
        this.customer_expense &&
        this.net_saving
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    ...mapMutations({
      updateKidsInfo: "UPDATE_KIDS_INFO",
      setClientInfo: "SET_CLIENT_INFO",
      setFactSheetTarget: "SET_FACTSHEET_TARGET",
      emptyFactSheetTarget: "EMPTY_FACTSHEET_TARGET"
    }),
    /* For Display Existing Information */
    setUpClientInfo(client_info) {
      this.customer_idcard = client_info.idcard_no;
      this.customer_fullname = client_info.full_name;
      this.customer_nickname = client_info.nick_name;
      this.customer_birthdate = new Date(client_info.dob);
      this.customer_career = client_info.career;
      this.customer_gender = client_info.gender;
      this.customer_income = client_info.income;
      this.customer_expense = client_info.expense;
    },
    setUpFamilyInfo(family_info) {
      this.kids = [];
      this.family_expense = family_info.expense;
      const children = family_info.child;
      if (children && children.length > 0) {
        children.forEach(child => {
          const kid = {
            name: child.name,
            gender: child.gender,
            dob: new Date(child.dob),
            sequence: child.sequence
          };
          this.kids.push(kid);
        });
      }
    },
    setUpTargetInfo(target_info) {
      if (target_info && target_info.length > 0) {
        let existing_targets = [];
        target_info.forEach(existing_target => {
          let title = "";
          switch (existing_target.target_type) {
            case "retire":
              title = "แผนการเกษียณ";
              break;
            case "education":
              title = "แผนการศึกษาบุตร";
              break;
            case "tax":
              title = "วางแผนภาษี";
              break;
            case "health":
              title = "ประกันสุขภาพ";
              break;
            case "family":
              title = "ทุนปกป้องครอบครัว";
              break;
            case "invest":
              title = "แผนการลงทุน";
              break;
            default:
              break;
          }
          const target = {
            title,
            type: existing_target.target_type,
            value: existing_target.description
          };
          existing_targets.push(target);
        });
        this.targets = existing_targets;
      }
    },
    /* Button Action Handler */
    textareaChange: function(value, index) {
      if (this.edited) {
        if (this.factsheet_target && this.factsheet_target.length > 0) {
          this.factsheet_target[index].description = value;
        } else if (this.targets && this.targets.length >= 0) {
          this.targets[index].value = value;
        }
      } else {
        this.targets[index].value = value;
      }
    },
    addChildButtonPressed: function() {
      const tmp_data = {
        name: null,
        gender: null,
        dob: null,
        sequence: null
      };
      this.kids.push(tmp_data);
    },
    removeChildButtonPressed: function(index) {
      if (this.kids.length > 0) {
        this.kids.splice(index, 1);
        this.updateFactInfoState();
      }
    },
    saveFactSheetInfoState: function() {
      if (!this.disabledNextButton && !this.edited) {
        let client_info = this.createClientInfoObject();
        let fact_info = this.createFactInfoTargetObject();
        this.setClientInfo(client_info);
        this.setFactSheetTarget(fact_info.target);
      }
      this.$emit("form_completed");
    },
    updateFactInfoState: function() {
      if (this.edited) {
        let client_info = this.createClientInfoObject();
        let fact_info = this.updateFactInfoTargetObject();
        this.setClientInfo(client_info);
        this.updateKidsInfo(client_info.family.child);
        this.setFactSheetTarget(fact_info.target);
        this.$emit("existing_sheet_updated");
      }
    },
    /* Modal Handler */
    presentTargetSelected: function() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: TargetSelectedForm,
        events: {
          selected: val => {
            // IF EDIT MODE
            if (this.edited) {
              // IF Existing Targets matched with incoming target use existing value...
              if (this.factsheet_target && this.factsheet_target.length > 0) {
                this.factsheet_target.forEach(existing_target => {
                  let position = val.findIndex(
                    incoming_target =>
                      incoming_target.type === existing_target.target_type
                  );
                  if (position >= 0) {
                    val[position].value = existing_target.description;
                  }
                });
                this.emptyFactSheetTarget();
              }
            }
            this.targets = val;
          }
        }
      });
    },
    /* API & PARAMS*/
    createClientInfoObject: function() {
      let client_info = {
        full_name: this.customer_fullname,
        nick_name: this.customer_nickname,
        dob: this.customer_birthdate,
        gender: this.customer_gender,
        career: this.customer_career,
        income: +this.customer_income,
        expense: +this.customer_expense,
        saving: +this.net_saving,
        family: {}
      };

      // Family Details
      if (+this.family_expense >= 0) {
        client_info.family["expense"] = 0;
        client_info.family.expense = +this.family_expense;
      }
      if (this.kids.length > 0) {
        client_info.family["child"] = [];
        this.kids.forEach((kid, index) => {
          kid.sequence = index;
          client_info.family.child.push(kid);
        });
      }
      return client_info;
    },
    createFactInfoTargetObject: function() {
      let fact_info = {};
      if (this.targets && this.targets.length > 0) {
        fact_info["target"] = [];
        this.targets.forEach(target => {
          const request_target = {
            target_type: target.type,
            description: target.value
          };
          fact_info.target.push(request_target);
        });
      }
      return fact_info;
    },
    updateFactInfoTargetObject: function() {
      let fact_info = {};

      if (this.targets && this.targets.length > 0) {
        fact_info["target"] = [];
        this.targets.forEach((target, index) => {
          let request_target = {};
          if (
            this.factsheet_target.length &&
            this.factsheet_target.length > 0
          ) {
            const existing = this.factsheet_target[index];
            request_target = {
              target_type: existing.target_type,
              description: existing.description
            };
          } else {
            request_target = {
              target_type: target.type,
              description: target.value
            };
          }
          fact_info.target.push(request_target);
        });
      }
      return fact_info;
    }
  },
  beforeMount() {
    if (this.edited) {
      this.setUpClientInfo(this.client);
      this.setUpFamilyInfo(this.client.family);
      this.setUpTargetInfo(this.factsheet_target);
    }
  }
};
</script>

<style scoped>
.is-align-end {
  align-items: flex-end;
}
</style>
